// extracted by mini-css-extract-plugin
export var actions = "P_cM";
export var buttonColumn = "P_cJ";
export var content = "P_cF";
export var contentButton = "P_cH";
export var contentOnly = "P_cG";
export var headline = "P_cL";
export var imageContainer = "P_br";
export var imageContent = "P_cD";
export var imageContentButton = "P_cK";
export var singleCtaContainer = "P_cB";
export var variant = "P_cC";
export var wrapper = "P_bF";